import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_55867a84 from 'nuxt_plugin_plugin_55867a84' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginsindexa88eb278_7c16e0e9 from 'nuxt_plugin_pluginsindexa88eb278_7c16e0e9' // Source: ./plugins.index.a88eb278.ts (mode: 'all')
import nuxt_plugin_cdn_261ff4c8 from 'nuxt_plugin_cdn_261ff4c8' // Source: ../pipes/cdn (mode: 'all')
import nuxt_plugin_date_9dddcfc2 from 'nuxt_plugin_date_9dddcfc2' // Source: ../pipes/date (mode: 'all')
import nuxt_plugin_duration_330ad585 from 'nuxt_plugin_duration_330ad585' // Source: ../pipes/duration (mode: 'all')
import nuxt_plugin_number_795aa90c from 'nuxt_plugin_number_795aa90c' // Source: ../pipes/number (mode: 'all')
import nuxt_plugin_producttype_0c27c8c9 from 'nuxt_plugin_producttype_0c27c8c9' // Source: ../pipes/product-type (mode: 'all')
import nuxt_plugin_shipmenttype_52f5f63c from 'nuxt_plugin_shipmenttype_52f5f63c' // Source: ../pipes/shipment-type (mode: 'all')
import nuxt_plugin_orderpurchasetype_27b383b6 from 'nuxt_plugin_orderpurchasetype_27b383b6' // Source: ../pipes/order-purchase-type (mode: 'all')
import nuxt_plugin_striphtml_167ab61e from 'nuxt_plugin_striphtml_167ab61e' // Source: ../pipes/strip-html (mode: 'all')
import nuxt_plugin_titlecase_0fc427b7 from 'nuxt_plugin_titlecase_0fc427b7' // Source: ../pipes/titlecase (mode: 'all')
import nuxt_plugin_truncate_1838d557 from 'nuxt_plugin_truncate_1838d557' // Source: ../pipes/truncate (mode: 'all')
import nuxt_plugin_currency_67db0ffc from 'nuxt_plugin_currency_67db0ffc' // Source: ../pipes/currency (mode: 'all')
import nuxt_plugin_decimal_7a2d4940 from 'nuxt_plugin_decimal_7a2d4940' // Source: ../pipes/decimal (mode: 'all')
import nuxt_plugin_emitter_f4ba2190 from 'nuxt_plugin_emitter_f4ba2190' // Source: ../plugins/emitter (mode: 'all')
import nuxt_plugin_lodash_52e6a2ea from 'nuxt_plugin_lodash_52e6a2ea' // Source: ../plugins/lodash (mode: 'all')
import nuxt_plugin_editor_6bfb673a from 'nuxt_plugin_editor_6bfb673a' // Source: ../plugins/editor (mode: 'client')
import nuxt_plugin_print_33c55e12 from 'nuxt_plugin_print_33c55e12' // Source: ../plugins/print (mode: 'all')
import nuxt_plugin_replacegraphqlerror_30ba6a15 from 'nuxt_plugin_replacegraphqlerror_30ba6a15' // Source: ../plugins/replace-graphql-error (mode: 'all')
import nuxt_plugin_graphql_10f6309a from 'nuxt_plugin_graphql_10f6309a' // Source: ../plugins/graphql (mode: 'all')
import nuxt_plugin_yoastseo_b116c1b4 from 'nuxt_plugin_yoastseo_b116c1b4' // Source: ../plugins/yoastseo.ts (mode: 'client')
import nuxt_plugin_access_63ce4c34 from 'nuxt_plugin_access_63ce4c34' // Source: ../plugins/role/access.ts (mode: 'all')
import nuxt_plugin_editor_445df586 from 'nuxt_plugin_editor_445df586' // Source: ../plugins/role/editor.ts (mode: 'all')
import nuxt_plugin_master_58c25c28 from 'nuxt_plugin_master_58c25c28' // Source: ../plugins/role/master.ts (mode: 'all')
import nuxt_plugin_helper_3bfeb1c4 from 'nuxt_plugin_helper_3bfeb1c4' // Source: ../plugins/acl/helper.ts (mode: 'all')
import nuxt_plugin_pipe_21a07d04 from 'nuxt_plugin_pipe_21a07d04' // Source: ../plugins/acl/pipe.ts (mode: 'all')
import nuxt_plugin_validationrules_0ed77b18 from 'nuxt_plugin_validationrules_0ed77b18' // Source: ../plugins/validation-rules.ts (mode: 'all')
import nuxt_plugin_replace_08c4ebaa from 'nuxt_plugin_replace_08c4ebaa' // Source: ../pipes/replace.ts (mode: 'all')
import nuxt_plugin_index_1e73732a from 'nuxt_plugin_index_1e73732a' // Source: ../plugins/api/report/index.ts (mode: 'all')
import nuxt_plugin_index_f6049a20 from 'nuxt_plugin_index_f6049a20' // Source: ../plugins/api/api-v2/index.ts (mode: 'all')
import nuxt_plugin_plugin_0b7d8302 from 'nuxt_plugin_plugin_0b7d8302' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_7f755f62 from 'nuxt_plugin_auth_7f755f62' // Source: ../plugins/auth.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Admin","title":"Asa Rén Dashboard","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"htmlAttrs":{"lang":"en"},"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_55867a84 === 'function') {
    await nuxt_plugin_plugin_55867a84(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsindexa88eb278_7c16e0e9 === 'function') {
    await nuxt_plugin_pluginsindexa88eb278_7c16e0e9(app.context, inject)
  }

  if (typeof nuxt_plugin_cdn_261ff4c8 === 'function') {
    await nuxt_plugin_cdn_261ff4c8(app.context, inject)
  }

  if (typeof nuxt_plugin_date_9dddcfc2 === 'function') {
    await nuxt_plugin_date_9dddcfc2(app.context, inject)
  }

  if (typeof nuxt_plugin_duration_330ad585 === 'function') {
    await nuxt_plugin_duration_330ad585(app.context, inject)
  }

  if (typeof nuxt_plugin_number_795aa90c === 'function') {
    await nuxt_plugin_number_795aa90c(app.context, inject)
  }

  if (typeof nuxt_plugin_producttype_0c27c8c9 === 'function') {
    await nuxt_plugin_producttype_0c27c8c9(app.context, inject)
  }

  if (typeof nuxt_plugin_shipmenttype_52f5f63c === 'function') {
    await nuxt_plugin_shipmenttype_52f5f63c(app.context, inject)
  }

  if (typeof nuxt_plugin_orderpurchasetype_27b383b6 === 'function') {
    await nuxt_plugin_orderpurchasetype_27b383b6(app.context, inject)
  }

  if (typeof nuxt_plugin_striphtml_167ab61e === 'function') {
    await nuxt_plugin_striphtml_167ab61e(app.context, inject)
  }

  if (typeof nuxt_plugin_titlecase_0fc427b7 === 'function') {
    await nuxt_plugin_titlecase_0fc427b7(app.context, inject)
  }

  if (typeof nuxt_plugin_truncate_1838d557 === 'function') {
    await nuxt_plugin_truncate_1838d557(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_67db0ffc === 'function') {
    await nuxt_plugin_currency_67db0ffc(app.context, inject)
  }

  if (typeof nuxt_plugin_decimal_7a2d4940 === 'function') {
    await nuxt_plugin_decimal_7a2d4940(app.context, inject)
  }

  if (typeof nuxt_plugin_emitter_f4ba2190 === 'function') {
    await nuxt_plugin_emitter_f4ba2190(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_52e6a2ea === 'function') {
    await nuxt_plugin_lodash_52e6a2ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_editor_6bfb673a === 'function') {
    await nuxt_plugin_editor_6bfb673a(app.context, inject)
  }

  if (typeof nuxt_plugin_print_33c55e12 === 'function') {
    await nuxt_plugin_print_33c55e12(app.context, inject)
  }

  if (typeof nuxt_plugin_replacegraphqlerror_30ba6a15 === 'function') {
    await nuxt_plugin_replacegraphqlerror_30ba6a15(app.context, inject)
  }

  if (typeof nuxt_plugin_graphql_10f6309a === 'function') {
    await nuxt_plugin_graphql_10f6309a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yoastseo_b116c1b4 === 'function') {
    await nuxt_plugin_yoastseo_b116c1b4(app.context, inject)
  }

  if (typeof nuxt_plugin_access_63ce4c34 === 'function') {
    await nuxt_plugin_access_63ce4c34(app.context, inject)
  }

  if (typeof nuxt_plugin_editor_445df586 === 'function') {
    await nuxt_plugin_editor_445df586(app.context, inject)
  }

  if (typeof nuxt_plugin_master_58c25c28 === 'function') {
    await nuxt_plugin_master_58c25c28(app.context, inject)
  }

  if (typeof nuxt_plugin_helper_3bfeb1c4 === 'function') {
    await nuxt_plugin_helper_3bfeb1c4(app.context, inject)
  }

  if (typeof nuxt_plugin_pipe_21a07d04 === 'function') {
    await nuxt_plugin_pipe_21a07d04(app.context, inject)
  }

  if (typeof nuxt_plugin_validationrules_0ed77b18 === 'function') {
    await nuxt_plugin_validationrules_0ed77b18(app.context, inject)
  }

  if (typeof nuxt_plugin_replace_08c4ebaa === 'function') {
    await nuxt_plugin_replace_08c4ebaa(app.context, inject)
  }

  if (typeof nuxt_plugin_index_1e73732a === 'function') {
    await nuxt_plugin_index_1e73732a(app.context, inject)
  }

  if (typeof nuxt_plugin_index_f6049a20 === 'function') {
    await nuxt_plugin_index_f6049a20(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0b7d8302 === 'function') {
    await nuxt_plugin_plugin_0b7d8302(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f755f62 === 'function') {
    await nuxt_plugin_auth_7f755f62(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
